import { addDoc, deleteDoc, doc, updateDoc } from 'firebase/firestore';

import { firestore, materialCollection } from '../Common/Firebase';

const addMaterial = async newData => {
  await addDoc(materialCollection, newData);
};

const removeMaterial = async id => {
  const docRef = doc(firestore, 'Materials', id);

  await deleteDoc(docRef);
};

const updateMaterial = async (id, newData) => {
  const docRef = doc(firestore, 'Materials', id);

  await updateDoc(docRef, newData);
};

export const materialsAPI = {
  addMaterial,
  removeMaterial,
  updateMaterial,
};
